// Trust Badges Component with Official Logos
// All badges link to their respective organizations

const TrustBadges = ({ variant = 'homepage' }) => {
  const badges = [
    {
      name: 'TDS',
      fullName: 'Tenancy Deposit Scheme',
      url: 'https://www.tenancydepositscheme.com/',
      logoUrl: '/logos/tds.svg'
    },
    {
      name: 'PRS',
      fullName: 'Property Redress Scheme',
      url: 'https://www.propertyredress.co.uk/',
      logoUrl: '/logos/prs.jpg'
    },
    {
      name: 'NRLA',
      fullName: 'National Residential Landlords Association',
      url: 'https://www.nrla.org.uk/',
      logoUrl: '/logos/nrla.png'
    }
  ];

  if (variant === 'footer') {
    return (
      <div className="border-t border-white/10 mt-12 pt-8">
        <div className="flex flex-col items-center">
          <p className="text-white/50 text-sm mb-6">Proud members of:</p>
          <div className="flex flex-wrap justify-center items-center gap-4 md:gap-6">
            {badges.map((badge) => (
              <a
                key={badge.name}
                href={badge.url}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white rounded-lg p-3 hover:shadow-lg transition-all duration-300 hover:scale-105"
                title={badge.fullName}
              >
                <img 
                  src={badge.logoUrl} 
                  alt={badge.fullName}
                  className="h-8 md:h-10 w-auto max-w-[120px] object-contain"
                  loading="lazy"
                />
              </a>
            ))}
          </div>
        </div>
      </div>
    );
  }

  // Homepage variant
  return (
    <section className="py-12 bg-white border-t border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <p className="text-slate-500 text-sm mb-8">Proud members of leading industry bodies</p>
          <div className="flex flex-wrap justify-center items-center gap-6 md:gap-10">
            {badges.map((badge) => (
              <a
                key={badge.name}
                href={badge.url}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:scale-105 transition-all duration-300"
                title={badge.fullName}
              >
                <div className="bg-white rounded-lg p-4 shadow-sm border border-slate-100 hover:shadow-md transition-shadow">
                  <img 
                    src={badge.logoUrl} 
                    alt={badge.fullName}
                    className="h-10 md:h-12 w-auto max-w-[140px] object-contain"
                    loading="lazy"
                  />
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustBadges;
